<template>
  <img
    src="~/assets/icon/icon-user-color.svg"
    alt=""
  />
</template>
